var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"radio"},_vm._l((_vm.data),function(item,index){return _c('div',{key:index,staticClass:"radio-item",on:{"click":function($event){return _vm.callback(index)}}},[_c('div',[(item.value == _vm.val)?_c('span'):_vm._e()]),_c('p',[_vm._v(_vm._s(item.label))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }